var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBackIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 10,
    viewBox: "0 0 22 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.46181 9.96448C5.61458 9.89932 5.7037 9.75598 5.7037 9.58658V6.66765H21.5926C21.8218 6.66765 22 6.48522 22 6.25066V3.74872C22 3.51416 21.8218 3.33173 21.5926 3.33173H5.7037V0.412801C5.7037 0.243399 5.60185 0.100059 5.46181 0.0349043C5.30903 -0.0302504 5.14352 -0.00418852 5.0162 0.11309L0.127315 4.72604C0.0509259 4.80423 0 4.92151 0 5.03878C0 5.15606 0.0509259 5.26031 0.127315 5.3385L5.0162 9.89932C5.14352 10.0036 5.30903 10.0296 5.46181 9.96448Z",
    fill: "#4A4A4A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBackIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/backIcon.df767d505f5e37e68c7acedd65d988a4.svg";